export const siteSettings = {
  name: "Beta Live Trading",
  link: "https://betalivetrading.net",
  email: "support@betalivetrading.net",
  appLink: "https://app.betalivetrading.net",
};
